var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "AppMyImage",
      class: _vm.mClass,
      attrs: {
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(0, 0, 0, 0.5)",
        "element-loading-text": "上传中",
      },
      on: { mouseenter: _vm.mouseenter, mouseleave: _vm.mouseleave },
    },
    [
      _c("ImagePreviewer", {
        staticStyle: { width: "100%", height: "100%" },
        attrs: { src: _vm.src, fit: _vm.fit },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show && !_vm.loading,
              expression: "show && !loading",
            },
          ],
          staticClass: "mask",
        },
        [
          _c("div", { staticClass: "mask_box" }, [
            !_vm.noDel
              ? _c("div", { staticClass: "mask_box_header" }, [
                  _c("i", {
                    staticClass: "el-icon-delete",
                    on: {
                      click: function ($event) {
                        return _vm.close()
                      },
                    },
                  }),
                ])
              : _c("div", { staticClass: "mask_box_header" }),
            !_vm.noCropper
              ? _c(
                  "div",
                  {
                    staticClass: "mask_box_footer",
                    on: {
                      click: function ($event) {
                        return _vm.cropper()
                      },
                    },
                  },
                  [_vm._v("裁剪")]
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }